<template>
  <div
    v-if="list && list.length > 0"
    class="video-model"
  >
    <h3>热播更新</h3>
    <ul class="video-model-list">
      <li
        v-for="(item, index) in list"
        v-show="show(index)"
        :key="index"
      >
        <a
          :href="item.playurl"
          :uigs="'out_hot_update_' + index"
        >
          <div class="video-model-img-h">
            <img-item :src="item.picurl" />
            <span
              v-if="item.vip === 1"
              class="tag-fee"
            >VIP</span>
            <div class="tag">
              <span class="tag-info">{{ item.update_info }}</span>
            </div>
          </div>
          <div class="video-model-desc">
            <p>{{ item.title }}</p>
            <p>{{ item.surtext }}</p>
          </div>
        </a>
      </li>
    </ul>
    <div class="video-model-btn">
      <a
        uigs="home_hot_update_change"
        @click="change"
      ><span class="change">换一换</span></a>
    </div>
  </div>
</template>

<script>
import ImgItem from './ImgItem';

export default {
  components: {
    ImgItem,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      num: 6,
      start: 0,
    };
  },
  methods: {
    show(index) {
      if (index >= this.start && index < this.start + this.num) {
        return true;
      }
      return false;
    },
    change() {
      const start = this.start + this.num;
      this.start = start >= this.list.length ? 0 : start;
    },
  },
};
</script>
